<template>
  <div class="category-list">
    <div
      v-for="category in categories[selectedProductType]"
      :key="category.id"
      class="category-item"
      :style="isSingle ? singleChoice : ''"
    >
      <label v-if="isMultiple">
        <input
          :checked="isChecked(category)"
          type="checkbox"
          @change="filterMultiple($event, category)"
        />
        <span>
          {{ category.name }}
        </span>
      </label>
      <button
        v-if="isSingle"
        type="button"
        @click="filterSingle(category)"
        :class="isSelected(category.id) ? 'selected' : ''"
      >
        {{ category.name }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "EcommerceFilterCategories",

  data() {
    return {
      singleChoice: {
        padding: 0,
        "background-color": "transparent",
        border: 0,
      },
    };
  },
  props: {
    categorySelection: {
      type: String,
      default: "multiple",
      validator: (value) => ["multiple", "single"].includes(value),
    },
    productType: {
      type: String,
    },
    preSelectedCategories: {
      type: Array,
    },
  },
  computed: {
    isSingle() {
      return this.categorySelection === "single";
    },
    isMultiple() {
      return this.categorySelection === "multiple";
    },
    ...mapState({
      categories: (state) => state.ecommerce.categories,
      selectedProductType: (state) => state.ecommerce.selectedProductType,
      selectedCategories: (state) => state.ecommerce.selectedCategories,
    }),
  },

  watch: {
    categories(newVal, oldVal) {
      this.loadPreSelected();
    },
    selectedProductType(newVal, oldVal) {
      this.loadPreSelected();
    },
  },
  created() {
    if (this.categorySelection === "single") {
      if (this.categories[this.productType].length > 0) {
        const firstCategory = this.categories[this.productType][0];
        this.$store.dispatch("updateSelectedCategories", [firstCategory]);
      }
    }
  },
  methods: {
    isSelected(id) {
      return this.selectedCategories.some((c) => c.id === id);
    },
    loadPreSelected() {
      // Default selection
      if (!!this.preSelectedCategories) {
        const foundCategories = [];

        for (const c of this.preSelectedCategories) {
          // Find it in the categories
          let cat = this.categories[this.selectedProductType].find(
            (e) => e.name === c
          );

          if (!!cat) {
            foundCategories.push(cat);
          }
        }

        const ca = [...this.selectedCategories, ...foundCategories];
        this.$store.dispatch("updateSelectedCategories", ca);
      }
    },
    filterMultiple(event, category) {
      if (event.target.checked) {
        this.$store.dispatch("updateSelectedCategories", [
          ...this.selectedCategories,
          category,
        ]);
        this.$store.dispatch("logProductFilter", category.name);
      } else {
        this.$store.dispatch(
          "updateSelectedCategories",
          this.selectedCategories.filter((c) => c.id !== category.id)
        );
      }
    },
    filterSingle(category) {
      this.$store.dispatch("updateSelectedCategories", [category]);
      this.$store.dispatch("logProductFilter", category.name);
    },
    isChecked(category) {
      return this.selectedCategories.some((c) => c.id === category.id);
    },
  },
};
</script>

<style scoped>
.category-list {
  display: flex;
  flex-wrap: wrap;
}

.category-item {
  flex: 0 0 160px;
  padding-right: 10px;
}

label {
  display: flex;
  align-items: center;
  font-size: 1rem;
  white-space: nowrap;
}

input[type="checkbox"] {
  border: 2px solid #888888;
  margin: 0 5px 0 0;
  width: 1rem;
  height: 1rem;
}

button {
  cursor: pointer;
  background-color: #ededed;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 0;
  width: 171px;
  height: 53px;
  margin: 10px;
}

.selected {
  background-color: #d1d1d1;
}

@media only screen and (max-width: 40em) {
  .category-list {
    display: grid;
    flex-wrap: nowrap;
    grid-template-columns: 1fr 1fr;
  }

  .category-item {
    flex: none;
    background-color: #ffffff;
    border: 1px solid #d1d1d1;
    display: flex;
    align-items: center;
    padding-left: 20px;
    height: 60px;
  }

  .category-item label {
    white-space: normal;
  }

  .category-item input[type="checkbox"] {
    flex-shrink: 0;
  }

  button {
    width: 100%;
    margin: 0;
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// Categories.vue?71a9442c